module.exports = __webpack_public_path__ + "static/media/07EchoMountainmuralfinisheddetail.7dd53bf2.webp";